export default "<app-map-radar></app-map-radar>\n"